import ReactMarkdown from "react-markdown";

export const TraitBar = ({ label, value, color = "#D4AF37", testid }) => (
  <div data-testid={testid}>
    <div className="flex items-baseline justify-between mb-2">
      <span className="text-slate-300 text-sm">{label}</span>
      <span className="font-mono text-sm" style={{ color }}>
        {value}%
      </span>
    </div>
    <div className="h-[6px] bg-slate-800">
      <div className="h-full transition-all duration-700" style={{ width: `${value}%`, backgroundColor: color }} />
    </div>
  </div>
);

export const AdvisorMarkdown = ({ children }) => (
  <ReactMarkdown
    components={{
      h1: (p) => <h3 className="font-serif text-lg text-[#D4AF37] mt-5 mb-2" {...p} />,
      h2: (p) => <h3 className="font-serif text-lg text-[#D4AF37] mt-5 mb-2 first:mt-0" {...p} />,
      h3: (p) => <h4 className="font-serif text-base text-[#D4AF37] mt-4 mb-2" {...p} />,
      p: (p) => <p className="text-slate-300 text-sm leading-relaxed mb-3" {...p} />,
      strong: (p) => <strong className="text-white font-semibold" {...p} />,
      em: (p) => <em className="text-slate-200" {...p} />,
      ul: (p) => <ul className="space-y-2 mb-4 ml-1" {...p} />,
      ol: (p) => <ol className="space-y-2 mb-4 ml-1 list-decimal list-inside" {...p} />,
      li: (p) => <li className="text-slate-300 text-sm leading-relaxed marker:text-[#D4AF37]" {...p} />,
      hr: () => <hr className="border-slate-800 my-5" />,
      code: (p) => <code className="text-[#D4AF37] bg-slate-900 px-1.5 py-0.5 text-xs" {...p} />,
      blockquote: (p) => <blockquote className="border-l-2 border-[#D4AF37] pl-4 italic text-slate-400 mb-3" {...p} />,
    }}
  >
    {children}
  </ReactMarkdown>
);
